import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_TITLE_PREFIX = '11-й форум для поваров «ЗАВТРАк ШЕФА»';

const EXPERT_TITLE_BASE = 'Лучшие шеф-повара на ЗАВТРАк ШЕФА';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  readonly #title = inject(Title);
  readonly #meta = inject(Meta);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const suffix = this.buildTitle(snapshot);
    this.#apply(this.#compose(suffix));
  }

  setExpertTitle(fullName: string): void {
    this.#apply(this.#compose(`${EXPERT_TITLE_BASE} - ${fullName}`));
  }

  #compose(suffix: string | undefined): string {
    return suffix ? `${APP_TITLE_PREFIX} - ${suffix}` : APP_TITLE_PREFIX;
  }

  #apply(value: string): void {
    this.#title.setTitle(value);
    this.#meta.updateTag({ property: 'og:title', content: value });
  }
}
